import { FunctionComponent, useEffect } from 'react';
import { useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { parseHtml } from '../Helper';
import type { Template } from '../../types';

interface UnsubscribedPageProps {
  template: Template;
}

export const UnsubscribedPage: FunctionComponent<UnsubscribedPageProps> = ({ template }) => {
  const appInsights = useAppInsightsContext();
  const defaultMessage = 'You have successfully unsubscribed from future surveys.';
  useEffect(() => {
    appInsights.trackPageView({ name: 'UnsubscribedPage.tsx' });
  }, [appInsights]);
  return (
    <div className="body text-center">
      <div>
        <p style={{ fontSize: '1.3em', whiteSpace: 'pre-wrap' }} id="uText">
          {parseHtml(template.unsubscribeText?.trim() ? template.unsubscribeText : defaultMessage)}
        </p>
      </div>
    </div>
  );
};
